// Port of TrailNavigation/NavigationLog.swift: a logging shim standing in for OSLog.
//
// Logging is limited to state transitions and unusual input so that per-GPS-fix work stays silent, and messages
// never carry coordinates. By default nothing is printed; the app (or a test) can install a sink.

export type LogLevel = 'debug' | 'info' | 'notice' | 'fault';

export type LogSink = (category: string, level: LogLevel, message: string) => void;

let sink: LogSink | undefined;

/** Installs (or removes, with `undefined`) the function receiving every log line of the engines. */
export function setLogSink(next: LogSink | undefined): void {
  sink = next;
}

export interface Logger {
  debug(message: string): void;
  info(message: string): void;
  notice(message: string): void;
  fault(message: string): void;
}

/** A logger for one category (Swift `Logger(subsystem:category:)`). */
export function makeLogger(category: string): Logger {
  const emit = (level: LogLevel) => (message: string) => sink?.(category, level, message);
  return { debug: emit('debug'), info: emit('info'), notice: emit('notice'), fault: emit('fault') };
}

/** Loggers used by the TrailNavigation module. */
export const NavigationLog = {
  logger: makeLogger('TrailNavigation'),
};
